export default {
  name: 'my-circle',
  template: `
    <div class="o-circle">
      <div class="o-aspect--square">
        <div class="o-circle__inner o-aspect__inner">
          <figure class="o-circle__image" :style="{ margin: marginValue + '%'}" v-if="imageFile">
            <img :src="imageSrc" :srcset="imageSrc + ' 1x, ' + imageSrcLarge + ' 2x'" width="512" height="512" v-if="!isLarge">
            <img :src="imageSrcLarge" v-else>
          </figure>
          <svg :viewBox="'0 0 ' + radius * 2 + ' ' + radius * 2">
            <path class="o-circle__path--outer" ref="outer" fill="none" stroke="#000000" :stroke-width="strokeWidth * activeItem[0].weight" stroke-linecap="round" />
            <path class="o-circle__path--inner" ref="inner" fill="none" stroke="#999999" :stroke-width="strokeWidth * activeItem[1].weight" stroke-linecap="round" />
            <path v-if="variant === 2" class="o-circle__path--extra" ref="extra" fill="none" stroke="#cccccc" :stroke-width="strokeWidth * activeItem[2].weight" stroke-linecap="round" />
          </svg>
        </div>
      </div>
    </div>
  `,
  props: {
    variant: {
      type: Number,
      default: 0
    },
    imageFile: {
      type: String
    },
    isLarge: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [
        [
          { name: 'outer', start: -145, end: 55, weight: 3 },
          { name: 'inner', start: 135, end: 260, weight: 2 }
        ],
        [
          { name: 'outer', start: 80, end: 280, weight: 3 },
          { name: 'inner', start: 10, end: 120, weight: 2 }
        ],
        [
          { name: 'outer', start: 180, end: 360, weight: 2 },
          { name: 'inner', start: -10, end: 55, weight: 1 },
          { name: 'extra', start: 45, end: 180, weight: 3 }
        ]
      ],
      strokeWidth: 10,
      radius: 150
    }
  },
  computed: {
    imageSrc () {
      if (this.imageFile) {
        return require('@/assets/images/' + this.imageFile + '.jpg')
      }
    },
    imageSrcLarge () {
      if (this.imageFile) {
        return require('@/assets/images/' + this.imageFile + '@2x.jpg')
      }
    },
    marginValue () {
      return Math.floor((this.strokeWidth * this.activeItem[0].weight) / (this.radius * 2) * 100)
    },
    activeItem () {
      return this.items[this.variant]
    }
  },
  methods: {
    polarToCartesian (centerX, centerY, radius, angleInDegrees) {
      let angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0
      return {
        x: centerX + (radius * Math.cos(angleInRadians)),
        y: centerY + (radius * Math.sin(angleInRadians))
      }
    },
    describeArc (x, y, radius, startAngle, endAngle) {
      let start = this.polarToCartesian(x, y, radius, endAngle)
      let end = this.polarToCartesian(x, y, radius, startAngle)
      let largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1'
      let d = [
        'M', start.x, start.y,
        'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y
      ].join(' ')
      return d
    }
  },
  mounted () {
    if (this.variant !== 2) {
      this.$refs.outer.setAttribute('d', this.describeArc(this.radius, this.radius, this.radius - (this.strokeWidth * 3) / 2, this.activeItem[0].start, this.activeItem[0].end))
      this.$refs.inner.setAttribute('d', this.describeArc(this.radius, this.radius, this.radius - (this.strokeWidth * 3), this.activeItem[1].start, this.activeItem[1].end))
    } else {
      this.$refs.outer.setAttribute('d', this.describeArc(this.radius, this.radius, this.radius - (this.strokeWidth * 3) / 2, this.activeItem[0].start, this.activeItem[0].end))
      this.$refs.inner.setAttribute('d', this.describeArc(this.radius, this.radius, this.radius - (this.strokeWidth * 3) / 2, this.activeItem[1].start, this.activeItem[1].end))
      this.$refs.extra.setAttribute('d', this.describeArc(this.radius, this.radius, this.radius - (this.strokeWidth * 3) / 2, this.activeItem[2].start, this.activeItem[2].end))
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/standard/my-circle.js